import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass({[`indicator-${ _ctx.light.color }`]: true })
  }, _toDisplayString(_ctx.turnsOn ? '▣' : '□'), 3 /* TEXT, CLASS */))
}